export default __webpack_public_path__ + "static/media/yeopen_small.5b49fd3f.jpg";